import React, { Component } from "react";
import { Paths, Urls } from "../../constants/UrlConstants";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { EPDomain_ROOT } from "../../constants/EP-config";
import EPQueryParams from "../../constants/EPQueryParams";

export const mapStateToProps = ({ unreadMessagesReducer = {} }) => {
  return{
    featureFlagEP : unreadMessagesReducer.featureFlagEP
  };
};

export class InboxLoader extends Component {

  constructor(props) {
    super(props);
    this.state = {
      url:Urls.EngagementPortal[EPDomain_ROOT].messages
    };
  }
  componentDidMount() {
    if( this.props.featureFlagEP === false || this.props.featureFlagEP === undefined) {
      this.props.history.replace(Paths.Inbox);
     }   
  }

  handleCallback = (childData) => {
    this.setState({ url: childData });
    if(this.props.featureFlagEP){
      this.props.history.replace(Paths.HomeRoot);
      window.open(childData, "_blank", "noopener");

    }
};

  render() {
      
    return (
      <EPQueryParams url={this.state.url} updatedURL={this.handleCallback}/>
      );
  }
}

const InboxLoaderRep = withRouter(InboxLoader);

export default connect(
  mapStateToProps)(InboxLoaderRep);